/* GENERATED FILE — DO NOT EDIT. Source: shared/assets/back-in-stock.js */
import { Component } from '@theme/component';

/**
 * Back-in-stock notify form.
 *
 * Only the Klaviyo path needs JavaScript — the `shopify_contact` provider posts
 * a normal Liquid contact form and works without this module. Klaviyo's
 * subscribe endpoint is public and CORS-enabled, so no app proxy is required.
 *
 * @extends {Component}
 */
class TiraBackInStock extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#form?.addEventListener('submit', this.#handleSubmit);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#form?.removeEventListener('submit', this.#handleSubmit);
  }

  /** @returns {HTMLFormElement | null} */
  get #form() {
    return this.querySelector('[data-bis-form]');
  }

  /** @returns {HTMLElement | null} */
  get #status() {
    return this.querySelector('[data-bis-status]');
  }

  /** @param {string} message */
  #setStatus(message) {
    const node = this.#status;
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
  }

  /** @param {SubmitEvent} event */
  #handleSubmit = (event) => {
    event.preventDefault();

    const form = this.#form;
    const input = form?.querySelector('input[type="email"]');
    if (!(input instanceof HTMLInputElement) || !input.checkValidity()) {
      input?.reportValidity();
      return;
    }

    const listId = this.dataset.klaviyoListId;
    const variantId = this.dataset.variantId;
    if (!listId || !variantId) {
      this.#setStatus(this.dataset.errorMessage ?? '');
      return;
    }

    const body = new URLSearchParams({
      a: listId,
      email: input.value,
      variant: variantId,
      platform: 'shopify',
    });

    const submit = form?.querySelector('button[type="submit"]');
    if (submit instanceof HTMLButtonElement) submit.disabled = true;

    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body,
    })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        this.#setStatus(this.dataset.successMessage ?? '');
        form?.reset();
      })
      .catch((error) => {
        console.warn('[tira-back-in-stock]', error);
        this.#setStatus(this.dataset.errorMessage ?? '');
      })
      .finally(() => {
        if (submit instanceof HTMLButtonElement) submit.disabled = false;
      });
  };
}

if (!customElements.get('tira-back-in-stock')) {
  customElements.define('tira-back-in-stock', TiraBackInStock);
}
